module.exports = __webpack_public_path__ + "media/images/knockout__winnerDeco@3x-732d3199d5bb5daf4c0b185e230889f9.png";